import React, { useState, useEffect, useRef, Component, memo } from "react";
import {
  AccordionTitle,
  AccordionContent,
  Accordion,
  Container,
  Dimmer,
  Grid,
  GridRow,
  GridColumn,
  Form,
  Select,
  Input,
  FormInput,
  TabPane,
  Tab,
  Button,
  TextArea,
  Checkbox,
  Icon,
  Segment,
  Label,
  Search,
  ButtonGroup,
  Menu,
  Loader,
} from "semantic-ui-react";
import "../scss/common.scss";
import { ReactComponent as IconImage } from "../assets/images/icon-img.svg";
import "lightbox2/dist/css/lightbox.css";
import "lightbox2/dist/js/lightbox-plus-jquery.js";

function InputComponent({
  nowEditTrade,
  handleTradeChange,
  index,
  editedTrades,
  categoryOptions,
  paymentOptions,
}) {
  const [newEditTrade, setNewEditTrade] = useState(nowEditTrade);

  useEffect(() => {
    console.log(newEditTrade);
  }, [newEditTrade]);

  return (
    <div className="tradeList">
      <div>{newEditTrade.id}</div>
      <div>
        {/* 日付 */}
        <p size="mini">
          <Input
            type="date"
            value={newEditTrade.date}
            onChange={(e) =>
              setNewEditTrade({
                ...newEditTrade,
                date: e.target.value,
              })
            }
            onBlur={(e) => handleTradeChange(index, "date", e.target.value)}
          />
        </p>
      </div>
      <div>
        {/* 取引先 */}
        <p size="mini">
          <FormInput
            fluid
            placeholder="取引先"
            value={newEditTrade.counterparty}
            onChange={(e) =>
              setNewEditTrade({
                ...newEditTrade,
                counterparty: e.target.value,
              })
            }
            onBlur={(e) =>
              handleTradeChange(index, "counterparty", e.target.value)
            }
          />
        </p>
      </div>
      <div>
        <p size="mini">
          <FormInput
            type="number"
            fluid
            placeholder="金額"
            value={newEditTrade.amount}
            onChange={(e) =>
              setNewEditTrade({
                ...newEditTrade,
                amount: e.target.value,
              })
            }
            onBlur={(e) => handleTradeChange(index, "amount", e.target.value)}
          />
        </p>
      </div>
      {/* カテゴリ */}
      <div>
        <p size="mini">
          <Select
            placeholder="category"
            options={categoryOptions}
            style={{ width: "100%", minWidth: "initial" }}
            value={newEditTrade.category || ""}
            onChange={(e, { value }) =>
              setNewEditTrade({
                ...newEditTrade,
                category: value,
              })
            }
            onBlur={(e, { value }) =>
              handleTradeChange(index, "category", value)
            }
          />
        </p>
      </div>
      {/* 決済手段 */}
      <div>
        <p size="mini">
          <Select
            placeholder="決済手段"
            options={paymentOptions}
            style={{
              width: "100%",
              minWidth: "initial",
            }}
            value={newEditTrade.payment_method || ""}
            onChange={(e, { value }) =>
              setNewEditTrade({
                ...newEditTrade,
                payment_method: value,
              })
            }
            onBlur={(e, { value }) =>
              handleTradeChange(index, "payment_method", value)
            }
          />
        </p>
      </div>
      {/* 立替精算 */}
      <div>
        <p size="mini">
          <Input
            type="date"
            value={newEditTrade.settlement_date || ""}
            onChange={(e) =>
              setNewEditTrade({
                ...newEditTrade,
                settlement_date: e.target.value,
              })
            }
            onBlur={(e) =>
              handleTradeChange(index, "settlement_date", e.target.value)
            }
          />
        </p>
      </div>
      {/* 画像 */}
      <div className="center">
        {newEditTrade.image_url && (
          <a href={newEditTrade.image_url} data-lightbox={newEditTrade.id}>
            <IconImage />
          </a>
        )}
      </div>
      {/* 削除 */}
      <div>
        <div className="flex-center">
          <Checkbox
            checked={editedTrades[index]?.delete_flg || newEditTrade.delete_flg}
            onChange={(e, data) =>
              handleTradeChange(index, "delete_flg", data.checked)
            }
          />
        </div>
      </div>
    </div>
  );
}

export default memo(InputComponent);
